import React from "react";
import { Routes, Route } from "react-router-dom";
import TransferPage from "./Pages/TransferPage";
import NFTTransferPage from "./Pages/NFTTransferPage";
import HomePage from "./Pages/HomePage";
import ConfigurePage from "./Pages/ConfigurePage";
const FilesRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/configure" element={<ConfigurePage />} />
      <Route path="/bridge" element={<TransferPage />} />
      <Route path="/nftbridge" element={<NFTTransferPage />} />
      <Route path="*" element={<>404 page not found !</>} />
    </Routes>
  );
};

export default FilesRoutes;
